module.exports = new __parcel__URL__("news06.a3e3fc7d.jpg").toString();